module.exports = __webpack_public_path__ + "media/img/ms-icon-150x150-1e6631aef5caf63fea0e307ff7e1567a.png";